import { Battery, BatteryWarning, Wifi, WifiOff } from 'lucide-react';
import { diasDesde, textoBateria, type Snapshot } from '@/lib/dispositivos';

/**
 * Lo que dice la última instantánea de la API, en dos chips: conexión y
 * batería. Sin instantánea (un bridge, un cajetín) no se pinta nada: no hay
 * nada que saber, y un «—» sugeriría que falla algo.
 */
export function ChipConexion({ snapshot }: { snapshot: Snapshot | null }) {
  if (!snapshot || snapshot.online === null) return null;
  const dias = diasDesde(snapshot.en);
  const titulo = `Última lectura ${dias === 0 ? 'hoy' : dias === 1 ? 'ayer' : `hace ${dias} días`}`;
  return snapshot.online ? (
    <span className="inline-flex items-center gap-1 text-xs text-green-700" title={titulo}>
      <Wifi size={13} /> Online
    </span>
  ) : (
    <span className="inline-flex items-center gap-1 text-xs text-red-700 font-medium" title={titulo}>
      <WifiOff size={13} /> Offline
    </span>
  );
}

export function ChipBateria({ snapshot }: { snapshot: Snapshot | null }) {
  const b = textoBateria(snapshot);
  if (!b) return null;
  return b.alerta ? (
    <span className="inline-flex items-center gap-1 text-xs text-red-700 font-medium">
      <BatteryWarning size={13} /> {b.texto}
    </span>
  ) : (
    <span className="inline-flex items-center gap-1 text-xs text-sereno-dark/60">
      <Battery size={13} /> {b.texto}
    </span>
  );
}
